import React from "react";
import {
  Flame,
  Bell,
  HandHelping,
  Headphones,
  Globe2,
  GraduationCap,
  ArrowUpRight,
} from "lucide-react";
import { SectionHeading, Reveal, TiltCard } from "./Atoms";

const CARDS = [
  {
    id: "card-prayer",
    title: "Request Prayer",
    body: "Submit a private prayer request to ministry leadership.",
    cta: "Request Prayer",
    href: "#prayer",
    icon: Flame,
    span: "lg:col-span-5",
  },
  {
    id: "card-updates",
    title: "Join RFMG Updates",
    body: "Ministry announcements, prayer gatherings, teachings, service recordings, fasting calls, Fire Hub updates.",
    cta: "Join Updates",
    href: "#updates",
    icon: Bell,
    span: "lg:col-span-7",
  },
  {
    id: "card-partner",
    title: "Partner With the Fire",
    body: "Give and support revival, discipleship, deliverance, evangelism, tent revivals, crusades, and Kingdom advancement.",
    cta: "Give / Partner",
    href: "#give",
    icon: HandHelping,
    span: "lg:col-span-7",
  },
  {
    id: "card-recordings",
    title: "Service Recordings",
    body: "Access recent teachings, prayer calls, revival services, and ministry recordings.",
    cta: "Listen Now",
    href: "#recordings",
    icon: Headphones,
    span: "lg:col-span-5",
  },
  {
    id: "card-firehubs",
    title: "Fire Hubs & Revival Hubs",
    body: "Prayer, training, discipleship, deliverance, evangelism, and regional revival mobilization.",
    cta: "Explore Fire Hubs",
    href: "#fire-hubs",
    icon: Globe2,
    span: "lg:col-span-5",
  },
  {
    id: "card-mentorship",
    title: "Prophetic Mentorship",
    body: "Prophetic training, apostolic equipping, spiritual covering, and deeper alignment.",
    cta: "Join Mentorship",
    href: "#mentorship",
    icon: GraduationCap,
    span: "lg:col-span-7",
  },
];

const HubBento = () => {
  return (
    <section id="hub" className="relative section-ember py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <SectionHeading
            overline="Enter the Hub"
            title={<>One altar. <span className="gold-text italic">Many doorways.</span></>}
            subtitle="One place to pray, connect, give, listen, grow, and stay aligned with the movement of revival."
          />
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6">
          {CARDS.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={c.id} delay={i * 80} className={`col-span-1 ${c.span || "lg:col-span-6"}`}>
                <TiltCard className="h-full" strength={4}>
                  <a
                    href={c.href}
                    className="bento-card h-full flex flex-col justify-between min-h-[260px]"
                    data-testid={c.id}
                  >
                    <span className="glow-blob" />
                    <div className="flex items-start justify-between">
                      <span className="icon-badge">
                        <Icon className="h-5 w-5 text-[#C9A44C]" strokeWidth={1.5} />
                      </span>
                      <ArrowUpRight className="h-5 w-5 text-[#C9A44C]/60 group-hover:text-[#C9A44C]" strokeWidth={1.5} />
                    </div>

                    <div className="mt-10">
                      <h3 className="font-serif-display text-[28px] sm:text-[32px] leading-tight text-[#F6F0E6]">
                        {c.title}
                      </h3>
                      <p className="mt-3 text-[#D9D9D9] text-[15px] leading-relaxed">
                        {c.body}
                      </p>
                    </div>

                    <div className="mt-8 inline-flex items-center gap-2 text-[12px] tracking-[0.24em] uppercase text-[#C9A44C]">
                      {c.cta}
                      <span className="h-px w-8 bg-[#C9A44C]/60" />
                    </div>
                  </a>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HubBento;
